"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var sjcl = require("sjcl");
var aws_workdocs_web_client_common_1 = require("@amzn/aws-workdocs-web-client-common");
var EncryptionService_1 = require("../services/EncryptionService");
exports.KEY_EXCHANGE_COOKIE_NAME = 'fe_key_exchange';
function getHandshakeContent(connId, cryptoKey) {
    var plainMessage = Math.random().toString(36);
    var encryptedMessage = EncryptionService_1.encrypt(plainMessage, cryptoKey);
    var handshakeContent = {
        key: sjcl.codec.base64.fromBits(cryptoKey),
        connectionID: connId,
        message: plainMessage,
        encryptedMessage: encryptedMessage,
    };
    return JSON.stringify(handshakeContent);
}
exports.getHandshakeContent = getHandshakeContent;
function setKeyExchangeCookie(connId, cryptoKey) {
    var handshakeContent = getHandshakeContent(connId, cryptoKey);
    if (aws_workdocs_web_client_common_1.BrowserService.isSafari()) {
        handshakeContent = 'wd_' + connId + '_start' + handshakeContent + 'wd_' + connId + '_end';
    }
    setCookie(exports.KEY_EXCHANGE_COOKIE_NAME, handshakeContent);
}
exports.setKeyExchangeCookie = setKeyExchangeCookie;
function setCookie(name, val) {
    var date = new Date();
    var days = 1;
    date.setTime(+date + days * 31104000000);
    for (var i = 0; i < 500; i++) {
        document.cookie = name + '=' + val + '; expires=' + date.toUTCString();
    }
}
function setKeyExchangeInfoToClipboard(connId, cryptoKey, metricService) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var handshakeContent, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    handshakeContent = getHandshakeContent(connId, cryptoKey);
                    return [4, window.navigator.clipboard.writeText(handshakeContent)];
                case 1:
                    _a.sent();
                    metricService.newCounterMetric('ClipboardHandshake_copy_to_clipboard', 1);
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    metricService.newCounterMetric('ClipboardHandshake_copy_to_clipboard', 0);
                    throw error_1;
                case 3: return [2];
            }
        });
    });
}
exports.setKeyExchangeInfoToClipboard = setKeyExchangeInfoToClipboard;
function generateNewRequestID() {
    return new Date().getTime();
}
exports.generateNewRequestID = generateNewRequestID;
function isExceptionalResponse(response) {
    if (response.ExceptionType || response.ExceptionMessage) {
        return true;
    }
    return false;
}
exports.isExceptionalResponse = isExceptionalResponse;
function isAuthenticationRequest(request) {
    return !!request.AuthenticationOperation;
}
exports.isAuthenticationRequest = isAuthenticationRequest;
function isRequestPartOfConnectProcess(request) {
    return isAuthenticationRequest(request) || request.Operation === 'SetConfiguration' || request.Operation === 'SaveClipboard';
}
exports.isRequestPartOfConnectProcess = isRequestPartOfConnectProcess;
function isSecureOperation(request) {
    return !isAuthenticationRequest(request) && request.Operation !== 'SaveClipboard';
}
exports.isSecureOperation = isSecureOperation;
